module.exports = __webpack_public_path__ + "static/media/school-profile-banner4.87069b5b.png";